import * as React from "react";
import { UitkTextInput, UitkFauxInput } from "uitk-react-input";
import { UitkToolbar, UitkToolbarProps, ToolbarType } from "uitk-react-toolbar";
import { UitkFullscreenDialog, UitkDialogAnimationType } from "uitk-react-dialog";
import { WizardDialogTrigger } from "./WizardDialogTrigger";
import { RoomPicker } from "./RoomPicker";
import { GuestDialogProps } from "../typings";
import { locKeys } from "./l10n";
import { useLocalization } from "@shared-ui/localization-context";

export const GuestDialog = (props: GuestDialogProps) => {
  const { formatText } = useLocalization();

  const dialogAttributes: UitkToolbarProps = {
    action: props.onDismiss,
    iconLabel: formatText(locKeys.cancelButton),
    header: formatText(locKeys.dialogTitle),
    type: ToolbarType.CLOSE,
  };

  return (
    <UitkFullscreenDialog
      className="GuestDialog uitk-grid uitk-grid-cell all-cell-1-1"
      dialogShow={true}
      animation={UitkDialogAnimationType.SLIDEUP}
    >
      <div className="uitk-cell">
        <UitkToolbar {...dialogAttributes} action={props.onDismiss.bind(this, WizardDialogTrigger.GUESTPICKER)} />
      </div>
      <RoomPicker {...props} />
    </UitkFullscreenDialog>
  );
};

export const GuestField = ({
  guestsVal,
  open,
  focusInput,
  invalid,
}: {
  guestsVal: string;
  open: () => void;
  focusInput: React.Ref<HTMLButtonElement>;
  invalid: string;
}) => {
  const { formatText } = useLocalization();

  return (
    <UitkTextInput
      id="destination-field"
      label={formatText(locKeys.guests)}
      value={guestsVal}
      className="is-hidden"
      icon="person"
      invalid={invalid}
    >
      <UitkFauxInput onClick={open} domRef={focusInput}>
        {guestsVal}
      </UitkFauxInput>
    </UitkTextInput>
  );
};
